import { css } from '@emotion/react';
import { theme } from '@frontend/theme';

export const submissionPanelDetailSectionStyle = css`
  padding: ${theme.spacing(2)};
  background: ${theme.colors.white};
  border-radius: ${theme.borderRadius.small};
`;
